/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-right-2': {
    width: 14,
    height: 13,
    viewBox: '0 0 14 13',
    data: '<path pid="0" d="M14 6.362L8.084 0H4.74l4.734 5.09H0v2.546h9.473l-4.734 5.091h3.345L14 6.362z" _fill="#fff"/>'
  }
})
